// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"79c01688","81":"a231cba9","133":"2f5a6138","140":"322e8203","186":"9f117a84","344":"91919b01","372":"3e3267c1","434":"70f595cf","614":"c2a8be78","738":"2d3af5bf","841":"34521c9f","849":"20ed6941","856":"d0404a5e"}[chunkId] + ".chunk.js";
};